// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"713":"98f25b8d","3352":"f8ca88b4","3690":"e5ed626e","3814":"253ab0be","4924":"b1c5ae78","5006":"d8dfc671","9541":"2fde62a7"}[chunkId] + ".js";
};